
'use strict'

import Joint from './Joint.js';

import skinDataToGeometry from './skinDataToGeometry.js'

import CannonController from './CannonController.js'

import JointMaterial from './JointMaterial.js'

import randomElement from './randomElement.js'

import getCustomDepthMaterial from './getCustomDepthMaterial.js'

import TWEEN from 'tween.js'

import JointTexture from './JointTexture.js'



var lerp = THREE.Math.lerp;

var mapLinear = THREE.Math.mapLinear;

var randf = THREE.Math.randFloat;



const isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

// StartAudioContext(Tone.context, '#container', ()=>{
//   // if(isSafari)  alert('StartAudioContext')
// });

var makeNote = ( name, duration, velocity) => {
  return {
    name: name,
    duration: duration || '32n',
    velocity: Math.min(velocity)
  }
}



var randf = THREE.Math.randFloat;

var Sketch = function(options){

  options = options || {};
  
  var debug = false;

  var updateVertexPositions = false;

  var elapsedTime = 0;

  var container = options.container || $("#container");

  var globeRad = 3;
  
  var goalPos = new THREE.Vector3( 0, 0, 0 );
  
  var attenuation = 0.995;
  
  var hingeRange = 6;

  var wigglyness = 1.5;
  
  var wigglySpeed = 6;
  
  var orig_wigglySpeed = wigglySpeed;
  
  var orig_wigglyness = wigglyness;
  
  var shadowRes = 2048;

  var attraction = 0.05;

  var bodySmoothing = 0.25;

  var animationGoal = new THREE.Vector3( 0, 0, 0 );


  // colors
  var c0 = new THREE.Color(0xffffff);
  var c1 = new THREE.Color(0xedff00);
  var orig_c0 = c0.clone();
  var orig_c1 = c1.clone();

  // three
  var view = new ThreeView(container);// boiler plate... couldn't this be passed in? then we could do a player...

  var renderer = view.setupRenderer();

  if(!isSafari) {
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  }
  renderer.setClearColor(0x333333, 0.1)

  var clock = new THREE.Clock();

  var scene = new THREE.Scene();
  scene.fog = new THREE.Fog( 0x000000, 100, 350 );

  var camera = new THREE.PerspectiveCamera(60, view.aspect, 1, 1000);
  camera.position.set(0, 150, 0)
  // camera.position.set(-2.8736756812862256, -185.7074131414838, 13.028144599380697)
  camera.lookAt( new THREE.Vector3(camera.position.x, camera.position.y-20, 0) );


  var controls = new THREE.OrbitControls( camera, renderer.domElement );
  // controls.enabled = false;
  controls.enableZoom = true;
  controls.enableRotate = false;
  controls.enablePan = false;
  controls.enableDamping = true;
  controls.dampingFactor = 0.5;
  controls.rotateSpeed = 0.5;
  controls.minDistance = globeRad + 4;
  controls.maxDistance = 180;

  controls.maxPolarAngle = 1;

  
  var makeSpot = () => {
    var spot = new THREE.SpotLight();

    spot.castShadow = true;
    spot.shadow.mapSize.width = shadowRes;
    spot.shadow.mapSize.height = shadowRes;
    spot.shadow.camera.near = 0.1;
    spot.shadow.camera.far = 100;
    spot.shadow.camera.fov = 10;

    // spot.penumbra = 1
    // spot.shadow.bias = 0.000001;

    return spot
  }

  var spot = makeSpot();
  spot.color.set(0xBBFFEE).multiplyScalar( 0.66 );
  // spot.position.lerp(camera.position, 0.5);
  spot.position.y += 150;
  spot.position.z -= 30;
  spot.lookAt(new THREE.Vector3( 0, 0, 0 ));
  scene.add(spot);


  var hemi = new THREE.HemisphereLight( 0x6688BB, 0x181844, 1 );
  scene.add( hemi );



  let box = new THREE.Mesh(new THREE.BoxGeometry(10,10,10), new THREE.MeshBasicMaterial({
    color: 'white',
    wireframe: true,
    side: 2
  }))

  

  var cc = CannonController({
    gravity: new CANNON.Vec3(0,-500,0),
    maxSubSteps: isSafari ? 2 : 10
  });

  var groundMaterial = new CANNON.Material("groundMaterial");
  
  // Adjust constraint equation parameters for ground/ground contact
  var ground_ground_cm = new CANNON.ContactMaterial(groundMaterial, groundMaterial, {
      friction: 100,
      restitution: 0.3,
      contactEquationStiffness: 1e8,
      contactEquationRelaxation: 3,
      frictionEquationStiffness: 1e8,
      frictionEquationRegularizationTime: 1,
  });

  // Add contact material to the world
  cc.world.addContactMaterial(ground_ground_cm);


  // var ground = new THREE.Mesh(
  //   new THREE.BoxGeometry(globeRad,globeRad,globeRad),
  //   new THREE.MeshLambertMaterial({
  //     color: 0x444444
  //   }));

  // ground.castShadow = false;
  // ground.receiveShadow = true;
  // scene.add(ground);
  // ground.body = cc.addBoxMesh(ground, {
  //   mass: 0,
  //   material: groundMaterial 
  // });
  

  // var ground = new THREE.Mesh(
  //   new THREE.SphereGeometry(globeRad, 30, 20),
  //   new THREE.MeshPhongMaterial( {
  //       color: 0xaaaaaa,
  //       side: 0,
  //       emissive: "white",
  //       emissiveIntensity: 0.035,
  //       shininess: 16.,
  //       wireframe: false
  //     }));
  // ground.castShadow = true;
  // ground.receiveShadow = true;
  // scene.add(ground);

  // ground.body = cc.addSphere(globeRad, {
  //   mass: 0,
  //   // material: groundMaterial 
  // });



  // DEBUG SPHERE
  var debugSphere = new THREE.Mesh(new THREE.SphereGeometry(1), new THREE.MeshBasicMaterial({
    color: 'red',
    wireframe: true,
    transparent: true,
    opacity: 0.5,
    blending: 2
  }))
  debugSphere.visible = debug;
  debugSphere.position.z = 100;
  debugSphere.body = cc.addSphere(1, {mass: 0});
  scene.add(debugSphere)


  var cPlane = cc.addPlane({ mass: 0, material: groundMaterial });
  cPlane.quaternion.setFromAxisAngle(new CANNON.Vec3( 1, 0, 0 ), Math.PI * -0.5);
  cPlane.position.z = -10;

  var groundPlane = new THREE.Mesh(new THREE.PlaneGeometry( 1000, 1000, 10, 10), new THREE.MeshLambertMaterial({
    color: 0x444444,
    side: 0
  }));
  groundPlane.visible = true;
  groundPlane.castShadow = false;
  groundPlane.receiveShadow = true;
  groundPlane.position.copy(cPlane.position)
  groundPlane.quaternion.copy(cPlane.quaternion)

  scene.add(groundPlane)




  var dragPlane = new THREE.Mesh(new THREE.PlaneGeometry( 600, 600, 10, 10), new THREE.MeshBasicMaterial( {
    color: 'magenta',
    wireframe: true
  } ));
  dragPlane.visible = false;

  scene.add(dragPlane)




  var dataTex = new THREE.DataTexture( new Uint8Array([255,0,255, 0,255,255]), 2, 1, THREE.RGBFormat)
  var updateDataTex = ()=>{

    let colorVals = c0.toArray().concat(c1.toArray());

    for(var i=0; i<colorVals.length; i++) {
      dataTex.image.data[i] = colorVals[i] * 255;
    }
    dataTex.needsUpdate = true;
  }
  updateDataTex();


  var skinLoader = new THREE.XHRLoader();
  skinLoader.setResponseType('json');
  

  // debug meshes
  let cube = new THREE.Mesh(new THREE.BoxGeometry(1,1,1), new THREE.MeshPhongMaterial({
    color: 'cyan',
    wireframe: true,
    transparent: true,
    opacity: 0.5,
    blending: 2
  }));


  let jointCube = new THREE.Mesh(cube.geometry, new THREE.MeshBasicMaterial( {
    color: 'red',
    wireframe: true
  } ) );
  jointCube.scale.multiplyScalar(0.5);

  var skins = [];
  var intersectables = [];

  var createSkin = (json, geometry) => {
    var skin = {
      skinObj: new THREE.Object3D(),
      raycastIntersects: [],
      rigidBodies: [],
      constraints: [],
      loaded: false,
      joints: [],
      geometry: null,
      material: null,
      mesh: null,
      jointTexture: null
    }

    var skinObj = skin.skinObj;
    scene.add(skinObj);

    // create the joints
    let jointMap = {}

    json['joints'].forEach( function( j ){
      
      let joint = new Joint({
        name: j.name,
        transform: new THREE.Matrix4().fromArray(j['transform']),
        rigidBody: j.rigidBody
      })

      skin.joints.push(joint);

      jointMap[j.name] = joint;

      // DEBUG
      if(debug)  joint.add(jointCube.clone());
    });


    // create the rigid bodies
    for(let i in json['rigidBodies']) {

      let data = json['rigidBodies'][i];
      
      let b = new THREE.Object3D();
      b.name = i
      b.applyMatrix(new THREE.Matrix4().fromArray(data['transform']))
      b.updateMatrixWorld(true);
      skinObj.add(b)
      skin.rigidBodies.push(b)
      
      let inv = new THREE.Matrix4().getInverse(b.matrixWorld)

      data.joints.forEach((j)=>{
        jointMap[j].applyMatrix(inv);
        b.add(jointMap[j])
      })

      // debug rigid body bounds
      let c = cube.clone();
      c.scale.multiply( new THREE.Vector3().fromArray(data['extents']) );
      c.visible = debug;
      b.add(c);

      b.body = cc.addBoxMesh( c, {
        position: b.position,
        mass: data.mass,
        restitution: data.restitution,
        material: groundMaterial
      });


      b.body.skin = skin;


      c.body = b.body;
      skin.raycastIntersects.push(c)
    }


    // set the initial joint offsets
    skinObj.updateMatrixWorld(true);

    skin.joints.forEach( j => {
      j.setOffset();
    });


    // create the constraints
    for(var i in json['constraints']) {

      let c = json["constraints"][i]
      let a = skinObj.getObjectByName(c['rigidBodyA']);
      let b = skinObj.getObjectByName(c['rigidBodyB'])
      
      let dataA = json['rigidBodies'][c['rigidBodyA']]
      let dataB = json['rigidBodies'][c['rigidBodyB']]
      
      let constraintPos = new THREE.Vector3().fromArray(c['translate']);
      
      // local axis in rigid bodies
      let invA = new THREE.Matrix4().getInverse(a.matrixWorld)
      let invB = new THREE.Matrix4().getInverse(b.matrixWorld)

      let pointInA = constraintPos.clone().applyMatrix4(invA);
      let pointInB = constraintPos.clone().applyMatrix4(invB);

      let axisA = pointInA.clone().normalize();//.negate();
      let axisB = pointInB.clone().normalize();//.negate();

      axisB.applyAxisAngle(new THREE.Vector3( 0, 1, 0 ), Math.PI * -0.5)
      axisA.applyAxisAngle(axisB, Math.PI * -0.5)



      let constraint = new CANNON.ConeTwistConstraint (
        a.body,
        b.body,
        {
          collideConnected: false,
          maxForce: Infinity,
          pivotA: new CANNON.Vec3().copy(pointInA),
          pivotB: new CANNON.Vec3().copy(pointInB),
          axisA: new CANNON.Vec3().copy(axisA),
          axisB: new CANNON.Vec3().copy(axisB),
          angle: 0.001,
          twistAngle: 0.001,
        } );

      cc.addConstraint(constraint)

      skin.constraints.push(constraint);
    }


    // set the initial joint offsets
    skinObj.updateMatrixWorld(true);

    skin.joints.forEach( j => {
      j.setOffset();
    });


    // put together the mesh
    let jointTransforms = skin.joints.map(j => {
      return j.transform
    })


    let jointTexture = new JointTexture(jointTransforms);
    var jointMaterial = new JointMaterial(jointTransforms);



    // jointMaterial.uniforms.hitColor.value.copy(c1)
    jointMaterial.uniforms.map.value = dataTex;
    jointMaterial.uniforms.jointTexture.value = jointTexture.texture;
    jointMaterial.uniforms.jointTextureDim.value.set( jointTexture.texture.image.width, jointTexture.texture.image.height);

    
    let mesh = new THREE.Mesh(geometry, jointMaterial);
    mesh.castShadow = true;
    mesh.receiveShadow = true;
    mesh.customDepthMaterial = getCustomDepthMaterial(jointMaterial, jointTransforms)


    skinObj.add(mesh);
    skin.geometry = geometry;
    skin.material = jointMaterial;
    skin.material = jointMaterial;
    skin.mesh = mesh;
    skin.jointTexture = jointTexture;

    skin.loaded = true;

    intersectables = intersectables.concat(skin.raycastIntersects);

    return skin;
  }


  var animateSkin = (skin, index) => {

    let step = 1 / (skins.length)

    // color
    skin.mesh.material.uniforms.hitColor.value.setHSL(step * skin.skinIndex, 1, 0.5)
  }



  skinLoader.load('assets/mesh.json', json => {

    let geometry = skinDataToGeometry(json);

    let count = isSafari ? 3 : 5;

    let rad = 60;

    let step = Math.PI * 2 / count;
    for (var i=0; i<count; i++) {

      let skin = createSkin(json, geometry);
      skins.push(skin);  

      skin.skinIndex = i;

      skin.rigidBodies.forEach( function( rb ){

        rb.body.position.x += Math.sin(i * step) * rad;
        rb.body.position.y = 100;
        rb.body.position.z += Math.cos(i * step) * rad;
        
        // rb.body.newPosition.copy(rb.body.position)
        // rb.body.newPosition.copy(rb.body.position)
      });  

      // // 
      // skin.synth = new Tone.MembraneSynth();
      // skin.synth.connect(gain);


      var stickMesh = new THREE.Mesh(cube.geometry,
        new THREE.MeshLambertMaterial( {
          color: c0,//new THREE.Color().setRGB(randf(0.5, 1.5),randf(0.5, 1.5),randf(0.5, 1.5))
        } ));

      stickMesh.castShadow = true;
      stickMesh.receiveShadow = true;

      skin.rigidBodies.forEach( (rb, index ) => {

        if(randf(0,1) < 0.5)  return;
      
        // add a stick
        let box = stickMesh.clone();
        box.position.copy(rb.position)
        box.scale.set(1,50,1);
        scene.add(box);

        box.body = cc.addBoxMesh( box, {
          position: rb.body.position,
          mass: 0.1,
          // material: groundMaterial
        });
        skin.rigidBodies.push(box)

        // lock constraint
        var lc = new CANNON.ConeTwistConstraint (
          rb.body,
          box.body,
          {
            collideConnected: false,
            maxForce: Infinity,
            pivotA: new CANNON.Vec3(0,0,0),
            pivotB: new CANNON.Vec3(0,randf(-23, 23),0),
            angle: 0,
            twistAngle: 0,
          });

        cc.addConstraint(lc)
      
      });

    }


    skins.forEach( animateSkin );
  
  });


  var updateSkin = skin => {

    if (skin.loaded) {


      skin.jointTexture.update();

      skin.joints.forEach( j => {
        j.updateTransform();
      });

      // rigid bodiy transforms
      let q = new THREE.Quaternion();
      let delta = new THREE.Vector3( 0, 0, 0 );

      let attractor = debugSphere.position;

      skin.rigidBodies.forEach( (b, i)=>{

        if (b.body) {

          b.body.velocity.x *= attenuation;
          b.body.velocity.y *= attenuation;
          b.body.velocity.z *= attenuation; 
          
          b.body.angularVelocity.x *= attenuation;
          b.body.angularVelocity.y *= attenuation;
          b.body.angularVelocity.z *= attenuation;


          delta.x = attractor.x -  b.body.position.x;
          delta.y = 0;
          delta.z = attractor.z - b.body.position.z;


          if(b.name === "bulletRigidBodyShape6") {

            let l = delta.length();

            skin.mesh.material.uniforms.hitVal.value = Math.pow(l / 150, 2);

            l = Math.min(20, l);

            delta.applyAxisAngle(new THREE.Vector3( 0, 1, 0 ), Math.PI * 0.5);

            b.body.angularVelocity.x += delta.x * 0.05 * l;
            b.body.angularVelocity.z += delta.z * 0.05 * l;

          }
          
          q.copy(b.body.quaternion)
          b.position.lerp(b.body.position, bodySmoothing);
          b.quaternion.slerp(q, bodySmoothing);

        }

      });
    }
  }

  view.update = function(){

    // if(Tone.context.state && Tone.context.state === "suspended") {
    //   Tone.context.resume().then(function() {
    //     console.log("AudioContext resumed!");
    //     // fire your callback here
    //   });
    // }

    elapsedTime = clock.getElapsedTime();
    
    TWEEN.update();

    animationGoal.copy(camera.position).normalize().multiplyScalar( globeRad * 4 );

    // oc.update(elapsedTime);
    cc.update(elapsedTime);

    controls.update();
    
    skins.forEach( function( skin ){
    
      updateSkin(skin);
    
    });


  };


  view.draw = function(){

    renderer.render(scene, camera, null, true);

  };


  view.onResize = function(){

    camera.aspect = view.aspect;
    camera.updateProjectionMatrix();

  };


  var raycaster = new THREE.Raycaster();
  var mouse = new THREE.Vector2();
  var mousedown = false;
  var dragging = false;
  var grabbed = false;
  var draggedBody, dragConstraint, grabbedSkin;



  var onPress = e => {

    mousedown = true;

    if(e.type === 'touchstart') {

      mouse.x = ( e.touches[0].pageX / window.innerWidth ) * 2 - 1;
      mouse.y = - ( e.touches[0].pageY / window.innerHeight ) * 2 + 1;

      if(e.touches.length > 1)  return;

    } else {
      mouse.x = ( e.pageX / window.innerWidth ) * 2 - 1;
      mouse.y = - ( e.pageY / window.innerHeight ) * 2 + 1;
    }

    raycaster.setFromCamera( mouse, camera );

    intersectables.forEach( function( m ){
      m.visible = true;
    });
    
    let intersects = raycaster.intersectObjects( intersectables );
    
    intersectables.forEach( function( m ){
      m.visible = debug;
    });

    if(intersects.length){

      grabbed = true;

      if(e.type === 'touchstart')  controls.enabled = false;
      controls.enableRotate = false;

      let skin = intersects[0].object.body.skin;

      skin.grabbed = true;
      grabbedSkin = skin;

      grabbedSkin.mesh.material.uniforms.hitVal.value = 1

      let p = intersects[0].point;

      dragPlane.position.copy(p);
      dragPlane.lookAt(camera.position);

      if(p.length() < globeRad) {
        p.normalize().multiplyScalar( globeRad + 0.5 );
      }

      debugSphere.position.copy(p)
      debugSphere.body.position.copy(debugSphere.position);

      dragConstraint = cc.addPointConstraint(
        intersects[0].object.body,
        new THREE.Vector3( 0, 0, 0 ),
        debugSphere.body,
        new THREE.Vector3( 0, 0, 0 ));
    }
  }

  var onRelease = e => {

    if(grabbed){
      cc.removeConstraint(dragConstraint)
    }

    if(!controls.enableRotate) {
      controls.enabled = true;
      controls.enableRotate = true;
    }

    if(grabbedSkin) {


      if(!dragging) {
        grabbedSkin.rigidBodies[0].body.velocity.y += 1000;

        grabbedSkin.mesh.material.uniforms.hitVal.value = 1;
        // grabbedSkin.synth.triggerAttackRelease(grabbedSkin.jumpNote, "2n");
      }

      new TWEEN.Tween(grabbedSkin.mesh.material.uniforms.hitVal)
        .to({value: 0}, 300)
        .start()

      
      grabbedSkin.grabbed = false;

      grabbedSkin = false;
      
    }
    
    mousedown = false;
    
    grabbed = false;

    dragPlane.visible = false;

    dragging = false;
  }


  var dragIntersects = [groundPlane, dragPlane]

  var onDrag = e => {

    if(mousedown) dragging = true;

    // if(grabbed){

      // grabbedSkin.mesh.material.uniforms.hitVal.value = 2

      if(e.type === 'touchmove') {

        mouse.x = ( e.touches[0].pageX / window.innerWidth ) * 2 - 1;
        mouse.y = - ( e.touches[0].pageY / window.innerHeight ) * 2 + 1;


        if(e.touches.length > 1)  return;

      } else {
        mouse.x = ( e.pageX / window.innerWidth ) * 2 - 1;
        mouse.y = - ( e.pageY / window.innerHeight ) * 2 + 1;
      }

      raycaster.setFromCamera( mouse, camera );

      dragPlane.lookAt(camera.position)

      dragPlane.visible = true;
      let intersects = raycaster.intersectObjects(dragIntersects);
      dragPlane.visible = false;


      if(intersects.length){

        let p = intersects[0].point;


        if(p.length() < globeRad) {
          p.normalize().multiplyScalar( globeRad + 0.5 );
        } 

        debugSphere.position.copy(p)
        debugSphere.body.position.copy(p);
      }
    // }
  }


  $(window).on('mousedown', onPress)
  $(window).on('mouseup', onRelease)
  $(window).on('mousemove', onDrag)

  container.on('touchstart', onPress);
  container.on('touchend', onRelease);
  container.on('touchmove', onDrag);


  $(window).on('keypress', e=>{
    console.log( e );

    switch(e.key) {
      case 'd':
      case 'D':
        debug = !debug
        break;

      case 'c':
        console.log( camera );
        break;
    }
  })


  return {
    begin: function(){
      view.begin();
    }
  };

};



window.onload = () => {

  var sketch = new Sketch();

  sketch.begin();

};


